import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-start",
  "use": "icon-start-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-start\"><path d=\"M512.275957 90.714489a421.46112 421.46112 0 1 1-421.46112 421.46112 421.912686 421.912686 0 0 1 421.46112-421.46112m0-80.278309a501.739429 501.739429 0 1 0 501.739428 501.739429 501.739429 501.739429 0 0 0-501.739428-501.739429z\" p-id=\"6758\" /><path d=\"M370.233524 655.22152c0 39.687589 28.147582 55.99412 62.717429 36.024891l247.608408-143.045911a38.082023 38.082023 0 0 0 0-72.099956L432.800431 333.004459c-34.419325-20.069577-62.717429-3.612524-62.717428 36.075065 0.150522 0.301044 0.150522 286.141996 0.150521 286.141996z\" p-id=\"6759\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/start.svg
// module id = FCpx
// module chunks = 25